'use es6';

import http from 'hub-http/clients/apiClient';
import { getId } from 'dashboard-lib/public/team/team-schema';
import indexBy from 'transmute/indexBy';
import fromJS from 'transmute/fromJS';
export const getAllTeam = () => http.get('app-users/v1/teams').then(res => indexBy(getId, fromJS(res)));
export const getTeamHierarchy = () => http.get('app-users/v1/teams/hierarchy').then(fromJS);